import BigDivider from '@/atoms/BigDivider';
import CheckFactionChip from '@/atoms/forms/CheckFactionChip';
import CheckSetChip from '@/atoms/forms/CheckSetChip';
import Grades from '@/atoms/forms/grades/Grades';
import Input from '@/atoms/forms/Input';
import RadioList from '@/atoms/forms/radio/RadioList';
import SearchSelect from '@/atoms/forms/Select/SearchSelect';
import Disclosure from '@/molecules/Disclosure';
import { ORIENTATION } from '@/types/utils';

export const cardFilterJson = [
  {
    name: 'factions',
    label: 'faction',
    source: 'factions',
    component: CheckFactionChip,
  },
  {
    name: 'rarity',
    label: 'rarity',
    source: 'rarity',
    component: Grades,
  },
  {
    name: 'cardSet',
    label: 'cardSet',
    source: 'cardSet',
    component: CheckSetChip,
  },
  {
    name: 'cardType',
    label: 'cardType',
    source: 'cardType',
    component: Grades,
  },
  {
    component: BigDivider,
  },
  {
    component: Disclosure,
    label: 'cardSubTypes',
    filters: [
      {
        name: 'cardSubTypes',
        label: 'cardSubTypes',
        source: 'cardSubTypes',
        component: SearchSelect,
      },
    ],
  },
  {
    label: 'keyword',
    component: Disclosure,
    filters: [
      {
        name: 'keyword',
        label: 'keyword',
        source: 'keyword',
        component: SearchSelect,
      },
    ],
  },
  {
    label: 'card_cost',
    component: Disclosure,
    filters: [
      {
        name: 'mainCost',
        label: 'mainCost',
        source: 'mainCost',
        component: Grades,
      },
      {
        name: 'recallCost',
        label: 'recallCost',
        source: 'recallCost',
        component: Grades,
      },
    ],
  },
  {
    name: 'attributes',
    label: 'attributes',
    component: Disclosure,
    filters: [
      {
        name: 'mountainPower',
        label: 'mountain',
        source: 'mountainPower',
        component: Grades,
      },
      {
        name: 'forestPower',
        label: 'forest',
        source: 'forestPower',
        component: Grades,
      },
      {
        name: 'oceanPower',
        label: 'ocean',
        source: 'oceanPower',
        component: Grades,
      },
    ],
  },
  {
    component: Disclosure,
    label: 'prices',
    filters: [
      {
        name: 'priceMax',
        label: 'priceMax',
        component: Input,
        inputProps: {
          type: 'number',
          min: 0,
          step: 0.01,
        },
      },
    ],
  },
  {
    label: 'ownerShip',
    component: Disclosure,
    filters: [
      {
        name: 'ownership',
        source: 'ownership',
        component: RadioList,
        inputProps: {
          orientation: ORIENTATION.HORIZONTAL,

          options: {
            0: {
              label: '0',
            },
            lt3: {
              label: 'lt3',
            },
            gt3: {
              label: 'gt3',
            },
          },
        },
      },
    ],
  },
  {
    label: 'cardSetReward',
    component: Disclosure,
    filters: [
      {
        name: 'cardSetReward',
        source: 'cardSetReward',
        component: RadioList,
      },
    ],
  },
  {
    name: 'artist',
    label: 'artist',
    component: Disclosure,
    filters: [
      {
        name: 'artist',
        label: 'artist',
        source: 'artist',
        component: SearchSelect,
      },
    ],
  },

  {
    label: 'foiled',
    component: Disclosure,
    filters: [
      {
        name: 'foiled',
        component: RadioList,
        inputProps: {
          orientation: ORIENTATION.HORIZONTAL,
          options: {
            true: {
              label: 'foiled',
            },
            false: {
              label: 'not-foiled',
            },
          },
        },
      },
    ],
  },
  {
    label: 'cardHistoryStatus',
    component: Disclosure,
    filters: [
      {
        name: 'cardHistoryStatus',
        component: RadioList,
        inputProps: {
          orientation: ORIENTATION.HORIZONTAL,
          options: {
            ERRATUM: {
              label: 'ERRATUM',
            },
            SUSPENDED: {
              label: 'SUSPENDED',
            },
          },
        },
      },
    ],
  },
  // TODO : https://app.clickup.com/t/8699fnn18
  // {
  //   label: 'altArt',
  //   component: Disclosure,
  //   filters: [
  //     {
  //       name: 'cardProducts',
  //       source: 'cardProducts',
  //       component: RadioList,
  //       inputProps: {
  //         orientation: ORIENTATION.HORIZONTAL,
  //       },
  //     },
  //   ],
  // },
];
